module.exports = __webpack_public_path__ + "img/bodsonImg3@2x.e543ddcd.jpg";